<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13hlMsJ/tc-custom/9780300210156.jpg?1726871266194" alt="This image is the cover for the book Hannibal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hannibal
      </h1>
      <p class="bookDescription body article font2">
        <b>The life of the great Carthaginian general who marched into Rome during the Second Punic War is reexamined in this revealing and scholarly biography.</b><br/>  <br/> Once of the greatest military minds of the Ancient World, Hannibal Barca lived a life of daring and survival, massive battles, and ultimate defeat. A citizen of Carthage and military commander in Punic Spain, he famously marched his war elephants and huge army over the Alps into Rome’s own heartland to fight the Second Punic War. Yet the Romans were the ultimate victors. They eventually captured and destroyed Carthage, and thus it was they who wrote the legend of Hannibal: a brilliant and worthy enemy whose defeat represented military glory for Rome.<br/>  <br/> In this groundbreaking biography, Eve MacDonald employs archaeological findings and documentary sources to expand the memory of Hannibal beyond his military career. Considering him in the context of his time and the Carthaginian culture that shaped him, MacDonald offers a complex portrait of a man from a prominent family who was both a military hero and a statesman. MacDonald also analyzes Hannibal’s legend over the millennia, exploring how statuary, Jacobean tragedy, opera, nineteenth-century fiction, and other depictions illuminate the character of one of the most fascinating figures in all of history.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eve MacDonald
      </h2>
      
      <p class="authorDescription body article">An archaeologist, lecturer, and travel guide, Eve MacDonald is currently lecturer in ancient history at Cardiff University. She lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00cea26a